import { Column, LoadingSkeleton, Placeholder, StyledTableCell, StyledTableRow } from '@components';

export const TableItemSkeleton = ({ headerColumns }: { headerColumns?: Column[] }) => {
  const numberOfItems = headerColumns?.length || 1;
  const component = (
    <StyledTableCell>
      <LoadingSkeleton />
    </StyledTableCell>
  );
  return (
    <StyledTableRow>
      <Placeholder numberOfItems={numberOfItems} component={component} />
    </StyledTableRow>
  );
};
